import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
import { buttonVariants } from '../../utils/motion';

export const MotionButton = React.forwardRef(({
  className,
  variant = "primary",
  size = "default",
  children,
  ...props
}, ref) => {
  const baseClasses = "inline-flex items-center justify-center rounded-lg font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";
  
  const variants = {
    primary: "bg-[#1F3C88] text-white hover:bg-[#1a3373] focus-visible:ring-[#1F3C88]",
    secondary: "bg-gradient-to-r from-[#FF5C8A] to-[#FF8C42] text-white hover:shadow-lg focus-visible:ring-[#FF5C8A]",
    outline: "border-2 border-[#1F3C88] text-[#1F3C88] hover:bg-[#1F3C88] hover:text-white",
    ghost: "text-[#1F3C88] hover:bg-[#1F3C88]/10"
  };
  
  const sizes = {
    sm: "h-9 px-4 text-sm",
    default: "h-11 px-6 text-base",
    lg: "h-13 px-8 text-lg",
    xl: "h-15 px-10 text-xl"
  };

  return (
    <motion.button
      ref={ref}
      className={cn(baseClasses, variants[variant], sizes[size], className)}
      variants={buttonVariants}
      initial="initial"
      whileHover="hover"
      whileTap="tap"
      {...props}
    >
      {children}
    </motion.button>
  );
});

MotionButton.displayName = "MotionButton";